import useWidgetComponents from './hooks/useWidgetComponents';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorHandler } from './components/ErrorHandler/ErrorHandler';

const App = () => {
  const { widgetData } = useWidgetComponents();

  return (
    <div>
      {widgetData.map((w, index) => {
        return (
          <ErrorBoundary key={index} FallbackComponent={ErrorHandler}>
            <w.component key={index} data={w.data} />
          </ErrorBoundary>
        );
      })}
    </div>
  );
};

export default App;
